import { render, staticRenderFns } from "./OrganGu.vue?vue&type=template&id=8a83d592&scoped=true&"
import script from "./OrganGu.vue?vue&type=script&lang=js&"
export * from "./OrganGu.vue?vue&type=script&lang=js&"
import style0 from "./OrganGu.vue?vue&type=style&index=0&id=8a83d592&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a83d592",
  null
  
)

export default component.exports